import { INTEGRATION_LAYOUT_CHANGED, INTEGRATION_SUBSCRIBE_TO_HISTORY, WINDOW_RESIZED } from 'common/actions';

/**
 * @type {integrationModel}
 */
const initialState = {
  layout: 'regular', // oneOf ["regular", "iframe"]
  baseUrl: window.location.origin,
  subscribedToHistory: false,
  isDevice: false,
};

/**
 * @param {integrationModel} state
 * @param {{type: Symbol, payload: *}} action
 * @return {{layout: string, subscribedToHistory: boolean}}
 */
export const integrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case INTEGRATION_SUBSCRIBE_TO_HISTORY:
      return {
        ...state,
        subscribedToHistory: true,
      };

    case INTEGRATION_LAYOUT_CHANGED:
      return {
        ...state,
        layout: action.payload.layout,
        portalUrl: action.payload.portalUrl,
      };

    case WINDOW_RESIZED:
      return {
        ...state,
        viewRange: action.payload.range,
        size: action.payload.size,
        isDevice: action.payload.isDevice,
      };

    default:
      return state;
  }
};
